<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row" v-if="author">
            <div class="col-lg-3 col-sm-3">
              <div class="item-image">
                <vue-load-image v-if="author && author[0].image">
                  <img slot="image" v-bind:src="`${IMAGEURL}${author[0].image}`" alt="Author Photo" class="img-responsive" />
                  <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Loading image..." />
                  <div slot="error">can't load image</div>
                </vue-load-image>
              </div>
            </div>

            <div class="col-lg-9 col-sm-9">
              <div>
                <h2 class="tangon" v-if="author">{{ author[0].author_name }}</h2>
              </div>
              <div class="item-details">
                <div class="item-description" v-html="`${author[0].description}`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="container" v-if="author[0].products && author[0].products.length > 0">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="col-lg-12 ">
              <div class="section-header">
                <h3>{{ author[0].author_name }}-এর আরও বই</h3>
              </div>
              <div class="section-items">
                <div class="row">
                  <div v-for="(item, index) in author[0].products" v-bind:key="index" class="col-lg-2 col-sm-6 col-6 section-item books">
                    <a :href="`${baseUrl}book/${item.id}`">
                      <span v-if="item.badge" class="badgeText">{{ item.badge }}</span>
                      <div v-if="item.discount > 0" class="discount-badge">
                        <span>{{ item.discount }}</span>
                        <span v-if="item.discount_type == 'Percent'">%</span>
                        <span v-else class="taka-off">Tk.</span>
                        <div>OFF</div>
                      </div>
                      <ProductImage :image="item.image" />
                      <ProductNameH4 :product_name="item.product_name" />
                      <!-- <h4 v-if="item.product_name.length < 14">
                        {{ item.product_name }}
                      </h4>
                      <h4 v-if="item.product_name.length >= 14" :title="`${item.product_name}`">
                        {{ item.product_name.substr(0, 14) + "..." }}
                      </h4> -->
                      <div class="item-price mt-2">
                        <div v-if="item.discount > 0" class="item-price">Price: Tk. {{ item.price }}
                        </div>
                        <div class="item-regular-price">Regular Price: Tk. {{ item.orginal_price }} </div>
                      </div>
                    </a>
                    <ItemHoverButtons :item="item" />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import ProductImage from './common/ProductImage.vue';
import ItemHoverButtons from "./common/ItemHoverButtons.vue";
import ProductNameH4 from "./common/ProductNameH4.vue";

export default {
  data() {
    return {
      author: [
        {
          author_name: null
        }
      ]
    };
  },
  components: {
    Layout,
    ProductImage,
    ItemHoverButtons,
    ProductNameH4
  },
  methods: {
    getAuthor() {
      fetch(this.APIURL + "author-profile/" + this.$route.params.id)
        .then(response => response.json())
        .then(json => (this.author = json.data));
    },
    // addToCart(row) {
    //   let itemObj = {
    //     session_id: localStorage.getItem("session_id"),
    //     product_id: row.id,
    //     image: row.image,
    //     price: row.price,
    //     quantity: 1,
    //     name: row.product_name
    //   };
    //   this.$helper.saveToCart(itemObj);
    //   var cartCount = this.$helper.cartCount();
    //   $(".cart-count").text(cartCount);
    //   this.flashMessage.success({ message: "Added item to cart" });
    // }
  },
  mounted() {
    this.getAuthor();
  }
};
</script>
